import { supabase } from '../supabase';

export async function getPublicProfile(id) {
  const { data, error } = await supabase.from('profiles').select('*').eq('id', id).maybeSingle();
  if (error) throw error;
  if (!data) return null;
  return {
    ...data,
    _id: data.id,
    firstName: data.first_name,
    lastName: data.last_name,
    dateOfBirth: data.date_of_birth,
    photoURL: data.photo_url,
    isAdmin: data.is_admin
  };
}
